	export enum NoteTypeEnum {
		Appointment = 1,
		SalesOrder = 2,
		Patient = 3,
		Claim = 4
	}
